import { Checkbox } from 'antd';
import { t } from '../../../../../services/i18n';
import { Colors } from '../../../../../styles/Colors';
import { GlobalStyleAttributes } from '../../../../../styles/GlobalStyles';
import VStack from '../../../../common/Layout/VStack';
import AppText from '../../../../common/AppText';
import { getHugSeriesEventOptions, getBoxTimeFormat } from '../../../../../services/Helpers';
import { useMemo } from 'react';
import { HUG_FULL_BOOKING, HUG_DAY_BOOKING } from '../../../../../services/ConstHelper';

const HugBookingOptionsCheckboxes = (props) => {
    const { eventData, bookingType, showError, onSelectSeriesEvents, selectedSeriesEvents } = props;
    const boxTimeFormat = getBoxTimeFormat();
    const options = useMemo(() => getHugSeriesEventOptions(eventData, boxTimeFormat), [eventData]);
    const selectedNumOfDays = parseInt(bookingType.split('_').pop(), 10)

    return (
        <VStack space={'0.5rem'}>
            {![HUG_FULL_BOOKING, HUG_DAY_BOOKING].includes(bookingType) &&
                <>
                    <AppText mediumFont>{t('dayOptions')}:</AppText>
                    <Checkbox.Group options={options} value={selectedSeriesEvents} onChange={onSelectSeriesEvents} style={{ flexDirection: 'column', gap: '5px' }} />
                </>
            }
            {showError && selectedNumOfDays &&
                <AppText color={Colors.error} fontSize={GlobalStyleAttributes.fonts.infoText} width='max-content' mediumFont>
                    {t(`select-hug-partial-day${selectedNumOfDays === 1 ? '' : 's'}-error`, { num: t(`${selectedNumOfDays}-days`) })}
                </AppText>
            }
        </VStack>
    );
};

export default HugBookingOptionsCheckboxes;
